import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { map, Observable } from 'rxjs';
import { UploadJsonComponent } from "../../shared/components/upload-json/upload-json.component";
import { AnalysisStateService } from '../../shared/services/analysisState.service';

@Component({
  selector: 'app-home-page',
  imports: [CommonModule, UploadJsonComponent],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss',
  standalone: true
})
export class HomePageComponent {
  showIntro$: Observable<boolean>;

  constructor(private analysisStateService: AnalysisStateService) {
    // Intro is hidden as soon as upload succeeds and the region tree becomes available.
    this.showIntro$ = this.analysisStateService.fileUploaded$.pipe(
      map((isUploaded) => !isUploaded)
    );
  }
}
